<template>
  <div id="music-view" class="music-view">
    <div
      id="music-view-scalable"
      class="music-view-scalable"
      :style="{
        transform: 'translate(-50%, -50%) scale(' + scale + ')',
      }"
    >
      <div
        @click="
          audioClick.play();
          redirectMain();
        "
        class="new-home-btn"
      >
        <img :src="homeIcon" alt="Home" class="new-icon" draggable="false" />
      </div>
      <img id="music-view-bcg" :src="musicConfig.backgroundSrc" />
      <!-- <music-player
        :backgroundText="currentBackgroundText"
        :title="currentTitle"
        :song="currentSong"
        :secondSong="currentSecondSong"
      ></music-player> -->
      <music-filter v-if="musicConfig" @filtersStatus="getFiltersStatus" :musicConfig="musicConfig" />
      <music-list
        :filtersStatus="filtersStatus"
        :songsList="musicConfig.songs"
        :musicListComponentStyle="musicConfig.customStyles.musicListComponentStyle"
        @emitSong="emitSong"
      />
      <music-player :song="currentSong" :backgroundText="'currentBackgroundText'" :title="currentTitle" />
    </div>

    <!-- <FlipBookV2 /> -->
  </div>
</template>

<script>
// import book from '@/config/bookpage.js';
// import musicList from '@/components/musicList/musicList.vue';

import MusicPlayer from './MusicPlayer.vue';
import MusicList from './MusicList.vue';
import MusicFilter from './MusicFilter.vue';

export default {
  components: { MusicList, MusicFilter, MusicPlayer },
  // @Prop() private bookType!;
  data() {
    return {
      prevRoute: null,
      scale: 1,
      currentSong: '',
      currentSecondSong: '',
      currentBackgroundText: '',
      currentTitle: '',
      musicConfig: {},
      bookConfig: {},
      filtersStatus: {},
    };
  },
  beforeMount() {
    try {
      this.musicConfig = require('@/config/PsMusicConfig/MusicConfig.js').default;
      // do stuff
    } catch (ex) {
      handleErr(ex);
    }
  },
  mounted() {
    try {
      this.audioClick = new Howl({
        src: require(`__mainSrcDir/assets/audio/click.mp3`),
        autoplay: false,
        loop: false,
        volume: 0.5,
      });
    } catch (e) {
      console.log(
        '%cAudioPath MusicView- error',
        'font-weight: bold; background: red; color: white; padding: 0px 10px'
      );
    }
    this.resizeWindow();

    //  console.log(this.musicConfig);
  },
  created() {
    window.addEventListener('resize', this.resizeWindow);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeWindow);
  },
  computed: {
    homeIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/book/headerBar/pikto_domek.svg`);
      } catch {
        console.log(
          '%cHomeIcon MzNextGrid- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
  methods: {
    redirectMain() {
      this.$router.push(`/`);
    },
    getFiltersStatus(val) {
      if (val) {
        this.filtersStatus = val;
      }
    },
    giveMeObjectWithKey(object, value) {
      return object[value];
    },
    emitSong(song, secondSong, backgroundText, title) {
      this.currentSong = song;
      this.currentSecondSong = secondSong;
      this.currentBackgroundText = backgroundText;
      this.currentTitle = title;
    },

    resizeWindow() {
      let itm = document.getElementById('music-view')?.getBoundingClientRect();
      if (itm) {
        this.scale = Math.min(itm.width / 1920, itm.height / 1080);
      }
    },
    setProp(directLocation, page) {
      //  console.log(directLocation);
      //  console.log(page);
      if (page) {
        //    console.log(page);
        this.$router.push({
          name: directLocation,
          params: {
            startPage: page.page ? page.page : null,
            id: page.id ? page.id : null,
            configId: page.configId ? page.configId : null,
          },
        });
      } else
        this.$router.push({
          name: directLocation,
        });
    },
    openLink(link) {
      window.open(link);
    },
  },
};
</script>
<style lang="sass" scoped>
$break-large: 1400px
#music-view
  width: 100vw
  height: 100vh
  #music-view-scalable
    width: 1920px
    height: 1080px
    top: 0
    left: 0
    text-align: center
    position: relative
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    transform-origin: center center
    overflow: hidden
  #music-view-bcg
    // border: 7px solid
    pointer-events: none;
    position: absolute
    width: 100%
    top: 0
    left: 0
    overflow-y: scroll
  .items-containers
    transition: 0.9s
    &:not(.noGrowEffect):hover
      transform: scale(1.12)
      transition: 0.9s
      opacity: 1 !important
    &:not(.nohover):hover
      transition: 0.9s
      opacity: 1 !important
    .glow-container
      cursor: pointer
      transition: .3s
      top: 0
      left: 0
      position: absolute;
      width: 100%;
      height: 100%;
      background: white;
      opacity: 0;
    &:not(.noGlowEffect):hover
      .glow-container
        opacity: .1 !important
  .container
    display: grid
    position: absolute
    .grid-items-containers
      font-family: Minion Pro Regular
      border-radius: 0px 0px 15px 15px
      transition: 0.4s
      cursor: pointer
      user-select: none

      &:not(.grid-nohover):hover
        // transform: scale(1.12)
        transform: translate(0px, -6%);
        transition: 0.4s
      .grid-glow-container
        cursor: pointer
        transition: .3s
        top: 0
        left: 0
        position: absolute;
        width: 100%;
        height: 100%;
        background: white;
        opacity: 0;
      &:not(.grid-nohover):hover
        .grid-glow-container
          opacity: .1 !important
.new-home-btn
  position: absolute
  z-index: 2
  top: 3%
  right: 0.15%
  width: 5%
  height: 5%
  cursor: pointer
  transition: 0.5s
  &:hover
    transform: scale(1.2)
  .new-icon
    width: 100%
    height: 100%
</style>
